import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element)
});

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as ajaxFormMap from './scripts/ajax-form-map';
ajaxFormMap.init({
    allowScriptTags: true
});

import * as googleMap from './scripts/google-map';
googleMap.init();

import * as parallax from './scripts/parallax';
parallax.init();

import * as fadeIn from './scripts/fade-in';
fadeIn.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    allowScriptTags: true,
    submitOnReset: true
});

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as datepicker from '@elements/datepicker';
datepicker.init();

import * as rangeDatepicker from '@elements/datepicker-range';
rangeDatepicker.init();

import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass:"icon icon-slide-right"
});


import * as overlayToggle from './scripts/overlay-toggle';
overlayToggle.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multiSelectDropdown from './scripts/multiselect-dropdown';
multiSelectDropdown.init();

import * as stepForm from './scripts/step-form';
stepForm.init();

import * as stepFromExtended from './scripts/step-form-extended';
stepFromExtended.init();

import * as affix from '@elements/affix';
app.affix = affix.init;

import * as anchorNav from '@elements/anchor-nav/bootstrap-5';
anchorNav.init(
    {
        renderItem: function (text, anchor) {
            return '<li class="nav-item anchor-nav__list-item list-inline-item js-anchor-nav__item"><a class="js-anchor-nav__link nav-link anchor-nav__link js-smoothscroll__link" data-scroll-offset="100" href="#' + anchor + '"><span class="anchor-nav__title">' + text + '</span></a></li>';
        },
        smoothScroll: true,
        scrollSpy: false,
        scrollSpyMethod: 'position',
        scrollSpyTarget: '.js-anchor-nav',
        scrollSpyOffset: 100
    },
    {
        list: '.js-anchor-nav__list',
        item: '.js-anchor-nav__item'
    }
);

import {find} from "@elements/dom-utils";
import ScrollSpy from './libs/bootstrap/scrollspy';
new ScrollSpy(document.body, {
    target: find('.js-anchor-nav'),
    offset: 100,
    method: 'position'
})

import * as anchorNavExtension from './scripts/anchor-nav-extension';
anchorNavExtension.init();

import * as scrollSliderExtension from './scripts/scroll-slider-extension';
scrollSliderExtension.init();

import * as datepickerBooking from '@elements/datepicker';

let result = [];
onFind('.js-datepicker-booking', function(datePicker){
    let weekdays = datePicker.dataset.datepickerWeekdays;
    weekdays = JSON.parse(weekdays);
    weekdays.map(function (item, index){
        if(item === true){
            result.push(index);
        }
    });
})

datepickerBooking.init( {
        enable: [
            function (date){
                return(date.getDay() === result[0] || date.getDay() === result[1] || date.getDay() === result[2] || date.getDay() === result[3] || date.getDay() === result[4] || date.getDay() === result[5] || date.getDay() === result[6])
            }
        ]
    },{
        base: '.js-datepicker-booking',
        input: '.js-datepicker-booking__input',
        altField: '.js-datepicker-booking__alt-field'
    }
);

import * as datePickerRangeExtension from './scripts/datepicker-range-extension';
datePickerRangeExtension.init();

import * as renderBookingNames from './scripts/render-booking-names';
renderBookingNames.init();

import * as ajaxFormTracking from './scripts/ajax-form-tracking';
ajaxFormTracking.init();
